export const USER_POINT_TYPES = {
    INCREASE: { value: "INCREASE", text: "적립" },
    DECREASE: { value: "DECREASE", text: "사용" },
};
